import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { Button } from 'antd';
import { useFlagrWelfareCenterValue } from 'hooks/business/system/useFlagr';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import welfareSvg from 'views/Main/components/AppHeader/assets/welfare.svg';
import { RightOutlined } from '@ant-design/icons';
import { WelfareCenterConfig } from 'services/api/flagr';
import useRedirect from 'hooks/useRedirect';
import { buryServiceMarketCarousel } from 'services/etc/bury';

function WelfareCenter() {
  const { t } = useTranslate();

  const { welfareCenterConfig: config } = useFlagrWelfareCenterValue() || {};

  if (!config || config.length === 0) {
    return null;
  }

  return (
    <Container>
      <img src={welfareSvg} alt="welfare" />
      <span>{t('market.福利中心')}</span>
      {config.length === 1 ? <Content config={config[0]} /> : <Carousel configList={config} />}
    </Container>
  );
}

function Content(props: { config: WelfareCenterConfig }) {
  const {
    config: { text2, redirectPath, iconUrl },
  } = props;

  const { t } = useTranslate();

  const systemLanguage = useSystemLanguageValue();

  const redirect = useRedirect();

  return (
    <ContentContainer>
      <div title={text2[systemLanguage]}>{text2[systemLanguage]}</div>
      <Button
        type="link"
        size="small"
        onClick={() => {
          redirect(redirectPath);
          buryServiceMarketCarousel(iconUrl);
        }}
        onTransitionEnd={(e) => e.stopPropagation()}
      >
        {t('market.了解详情')}
        <RightOutlined />
      </Button>
    </ContentContainer>
  );
}

function Carousel(props: { configList: WelfareCenterConfig[] }) {
  const { configList } = props;

  const [rising, setRising] = useState(false);

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextIndex = currentIndex >= configList.length - 1 ? 0 : currentIndex + 1;

  const { [currentIndex]: current, [nextIndex]: next } = configList;

  useEffect(() => {
    const timer = setInterval(() => {
      setRising(true);
    }, 10 * 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <CarouselContainer rising={String(rising)}>
      <div
        onTransitionEnd={() => {
          setRising(false);
          setCurrentIndex(nextIndex);
        }}
      >
        <Content config={current} />
        <Content config={next} />
      </div>
    </CarouselContainer>
  );
}

export default WelfareCenter;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  padding: 0 10px;
  background: var(--fett-bg-panel);
  border: 0;
  border-bottom: 1px solid var(--fett-border-default);
  border-radius: 4px 4px 0 0;

  > * {
    flex: 0 0 auto;
  }
  > img {
    margin-bottom: 2px;
  }
  > span {
    padding: 0 14px 0 7px;
    color: #5161c4;
  }
  > div {
    flex: 1 0 0;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
  font-size: 12px;
  color: var(--fett-text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  > div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  > button {
    font-size: 12px;
  }
`;

const CarouselContainer = styled.div<{ rising: string }>`
  height: 32px;
  overflow: hidden;
  > div {
    transform: ${({ rising }) => (rising === 'true' ? 'translateY(-32px)' : 'translateY(0)')};
    transition: ${({ rising }) => (rising === 'true' ? 'all .3s' : 'none')};
  }
`;
